<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	role="img"
	[class]="'tw-block ' + sizeClassResolved"
	[attr.aria-label]="resolvedAria"
	[style.color]="tierHexColor"
	stroke="currentColor"
	stroke-width="1.5"
	stroke-linecap="round"
	stroke-linejoin="round"
>
	<ng-container [ngSwitch]="tierIdx">
		<!-- 1 Onyx (emerald cut — elongated facets, polished highlight) -->
		<g *ngSwitchCase="1">
			<polygon fill="currentColor" fill-opacity="0.3" points="9 3 15 3 19.5 7.5 19.5 16.5 15 21 9 21 4.5 16.5 4.5 7.5" />
			<polygon fill="none" stroke-opacity="0.55" points="10.5 7 13.5 7 16.5 10 16.5 14 13.5 17 10.5 17 7.5 14 7.5 10" />
			<path fill="none" stroke-opacity="0.45" d="M9 3l1.5 4M15 3l-1.5 4M19.5 7.5l-3 2.5M19.5 16.5l-3-2.5M15 21l-1.5-4M9 21l1.5-4M4.5 16.5l3-2.5M4.5 7.5l3 2.5" />
			<path fill="none" stroke-opacity="0.3" d="M9 10.5Q12 8.5 15 10.5" />
		</g>

		<!-- 2 Carnelian (cushion cut) -->
		<g *ngSwitchCase="2">
			<rect x="4" y="4" width="16" height="16" rx="4.5" fill="currentColor" fill-opacity="0.2" />
			<rect x="8.5" y="8.5" width="7" height="7" rx="1.5" fill="none" stroke-opacity="0.4" />
			<path fill="none" stroke-opacity="0.35" d="M12 4v4.5M20 12h-4.5M12 20v-4.5M4 12h4.5M5.3 5.3l3.6 3.6M18.7 5.3l-3.6 3.6M18.7 18.7l-3.6-3.6M5.3 18.7l3.6-3.6" />
		</g>

		<!-- 3 Citrine (hex brilliant) -->
		<g *ngSwitchCase="3">
			<polygon fill="currentColor" fill-opacity="0.2" points="12 2 19 6 19 14 12 22 5 14 5 6" />
			<polygon fill="none" stroke-opacity="0.4" points="12 6 16 8.5 16 13 12 17 8 13 8 8.5" />
			<path fill="none" stroke-opacity="0.35" d="M12 2v4M19 6l-3 2M12 22v-4M5 6l3 2" />
		</g>

		<!-- 4 Moonstone (light faceted octagon — soft fills, thin facet lines) -->
		<g *ngSwitchCase="4">
			<polygon fill="currentColor" fill-opacity="0.15" points="7 3 17 3 21 7 21 17 17 21 7 21 3 17 3 7" />
			<polygon fill="none" stroke-opacity="0.4" points="9 6 15 6 18 9 18 15 15 18 9 18 6 15 6 9" />
			<path fill="none" stroke-opacity="0.35" d="M7 3l2 3M17 3l-2 3M21 7l-3 2M21 17l-3-2M17 21l-2-3M7 21l2-3M3 17l3-2M3 7l3 2" />
		</g>

		<!-- 5 Pearl (sphere + highlight) -->
		<g *ngSwitchCase="5">
			<circle cx="12" cy="12" r="7.5" fill="currentColor" fill-opacity="0.2" />
			<circle cx="12" cy="12" r="7.5" fill="none" stroke-opacity="0.4" />
			<path fill="none" stroke-opacity="0.3" d="M8 8.5Q10 6.5 12 7.5" />
			<path fill="none" stroke-opacity="0.25" d="M12 5v2.5" />
		</g>

		<!-- 6 Amethyst -->
		<g *ngSwitchCase="6">
			<path fill="currentColor" fill-opacity="0.2" d="M12 2 C 12 2, 20 9, 20 15 C 20 19.418, 16.418 23, 12 23 C 7.582 23, 4 19.418, 4 15 C 4 9, 12 2, 12 2 Z" />
			<path fill="none" stroke-opacity="0.4" d="M12 6 C 12 6, 16 11, 16 15 C 16 17.2, 14.2 19, 12 19 C 9.8 19, 8 17.2, 8 15 C 8 11, 12 6, 12 6 Z" />
			<path fill="none" stroke-opacity="0.4" d="M12 23v-4M20 15h-4M4 15h4M12 6v13M8 15h8" />
		</g>

		<!-- 7 Sapphire -->
		<g *ngSwitchCase="7">
			<polygon fill="currentColor" fill-opacity="0.2" points="12 2 21 7.2 21 16.8 12 22 3 16.8 3 7.2" />
			<polygon fill="none" stroke-opacity="0.4" points="12 7.5 16.5 10 16.5 14 12 16.5 7.5 14 7.5 10" />
			<path fill="none" stroke-opacity="0.4" d="M12 2v5.5M21 7.2l-4.5 2.8M21 16.8l-4.5-2.8M12 22v-5.5M3 16.8l4.5-2.8M3 7.2l4.5 2.8" />
		</g>

		<!-- 8 Emerald -->
		<g *ngSwitchCase="8">
			<polygon fill="currentColor" fill-opacity="0.2" points="7 3 17 3 21 7 21 17 17 21 7 21 3 17 3 7" />
			<polygon fill="none" stroke-opacity="0.4" points="9 6 15 6 18 9 18 15 15 18 9 18 6 15 6 9" />
			<path fill="none" stroke-opacity="0.4" d="M7 3l2 3M17 3l-2 3M21 7l-3 2M21 17l-3-2M17 21l-2-3M7 21l2-3M3 17l3-2M3 7l3 2" />
		</g>

		<!-- 9 Ruby -->
		<g *ngSwitchCase="9">
			<polygon fill="currentColor" fill-opacity="0.2" points="12 2 21 11 12 22 3 11" />
			<polygon fill="none" stroke-opacity="0.4" points="12 6 16 11 12 17 8 11" />
			<path fill="none" stroke-opacity="0.4" d="M12 2v4M21 11h-5M12 22v-5M3 11h5M8 11h8M12 6v11" />
		</g>

		<!-- 10 Diamond -->
		<g *ngSwitchCase="10">
			<polygon fill="currentColor" fill-opacity="0.2" points="6 3 18 3 22 9 12 22 2 9" />
			<polygon fill="none" stroke-opacity="0.4" points="9 3 15 3 18 9 12 12 6 9" />
			<path fill="none" stroke-opacity="0.4" d="M6 3v6M18 3v6M22 9H2M12 22V12M12 22L6 9M12 22l6-13M9 3l3 6M15 3l-3 6" />
		</g>
	</ng-container>
</svg>
